<div #imageRoot
     class="ng-image showHotelInfo"
     data-target-tab="tabPhotos">
     <img *ngIf="!isPhotosLoaded"
          [attr.src]="mainPhotoSrc"
          [attr.alt]="tour.hotelName"
          class="ng-main-photo" />

     <div *ngIf="isPhotosLoaded"
          #swiperGallery
          class="ng-slider swiper">
          <div class="swiper-wrapper">
               @for (photo of imageCollection; track $index) {
                    <div class="swiper-slide">
                         <img [attr.src]="photo"
                              [attr.alt]="tour.hotelName"
                              class="ng-main-photo" />
                    </div>
               }
          </div>
     </div>

     <div *ngIf="isPhotoLoading"
          class="ng-slider-loader"></div>

     <ng-container *ngIf="isSliderAvailable">
          <button *ngIf="isPrevArrowVisible"
                  type="button"
                  class="ng-slider-arrow ng-slider-arrow--prev"
                  (click)="onPrevPhoto($event)"
                  aria-label="Предыдущее фото"></button>
          <button type="button"
                  class="ng-slider-arrow ng-slider-arrow--next"
                  (click)="onNextPhoto($event)"
                  aria-label="Следующее фото"></button>

     </ng-container>

     <span *ngIf="isShowDiscount"
           class="ng-discount">-{{ tour.discount }}%</span>

     <app-tour-recommendations *ngIf="tour.isRecommended" [tour]="tour"></app-tour-recommendations>
</div>
